export default {"src":"/_next/static/media/loader.4e504446.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};